// removed by extract-text-webpack-plugin
module.exports = {"accordion":"_296L1rR5i6JBv7ZK2f8Vy6","accordionSection":"_1VnzkWmBW-iS1FzHlqglpF","accordionSectionTitle":"_1tssc_nmCOo4lkXkksiG7U","accordionHeader":"_1-CrlUqnqlvsWY0T57TDcW","accordionSectionContent":"_3rospCiFgnEfchzlaA7CYY","open":"_3H-9bGRfYpe8hiJA7mOZcN"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OMComponents/OMAccordion/OMAccordion.scss
// module id = 1651
// module chunks = 0